import { StyledComponent } from '@emotion/styled';
import { styled } from '@mui/material/styles';
import MuiToggleButtonGroup, {
  ToggleButtonGroupProps,
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';

export const ToggleButtonGroup: StyledComponent<ToggleButtonGroupProps> = styled(MuiToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    border: 1,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.75),
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      border: `1px solid transparent`,
      marginLeft: -1,
    },
}));
